import { Link, useNavigate, useParams } from "react-router-dom";
import HeaderMenu from "../sidebar/headermenu";
import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import PlaceHolder from "../../utils/placeholder";
import { GetArtistProfile } from "../../apis/user/get_artist_profile";
import AddArtistPhotos from "./add_artist_photos";
import EditArtistProfile from "./edit_artist_profile";
import { RemoveSubMediaApi } from "../../apis/user/remove_submedia_api";

export default function ArtistProfile() {
    const navigate = useNavigate();
    const params = useParams({ userId: String });
    const userData = {};

    const [ArtData, setArtData] = useState('');
    const [acode, setAcode] = useState('');
    const [ApiStatus, setApiStatus] = useState(API_STATUS);
    const [vlinks, setVlinks] = useState([]);
    const [loginId, setLoginId] = useState('');
    const [addMedia, setAddMedia] = useState(false);
    const [reload, setReload] = useState(false);
    const [photos, setPhotos] = useState([]);
    const [videos, setVideos] = useState([]);
    const [editArt, setEdit] = useState(false);
    const [delApi, setdelApi] = useState(API_STATUS);

    useEffect(() => {
        console.log(vlinks);
    }, [vlinks]);


    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);

            const login_data = sessionStorage.getItem('LOGIN_DATA');
            const udata = JSON.parse(login_data);
            setAcode(udata['access']);
        }
    }, []);

    useEffect(() => {
        if (params.status != null && loginId === params.userId) {
            setAddMedia(true);
        }
        GetArtistProfile(params.userId, setApiStatus);
    }, []);

    useEffect(() => {
        if (reload) {
            setReload(false);
            GetArtistProfile(params.userId, setApiStatus);
        }

    }, [reload]);

    useEffect(() => {
        if (!ApiStatus.isError && !ApiStatus.isLoader && ApiStatus.data != null) {
            let res = ApiStatus.data;
            setArtData(res.data);
            if (res.data['video'] !== "") {
                let vl = res.data.video.split('\n');
                setVlinks(vl);
            }
            if (res.data['photos'] != null) {
                setPhotos(JSON.parse(res.data['photos']));
            }
            if (res.data['videos'] != null) {
                setVideos(JSON.parse(res.data['videos']));
            }
        }
    }, [ApiStatus]);

    const deletePhoto = (i) => {
        let id = photos[i].id;
        let path = photos[i].path;
        let relative_path = path.replace('https://filmwings.com/media/', '');
        const body = { id: id, relativePath: relative_path };
        RemoveSubMediaApi(body, setdelApi);
        setPhotos(prevItems => {
            const newItems = [...prevItems];
            newItems.splice(i, 1);
            return newItems;
        });
    }

    const deleteVideo = (i) => {
        let id = videos[i].id;
        RemoveSubMediaApi(id, acode, setdelApi);
        setVideos(prevItems => {
            const newItems = [...prevItems];
            newItems.splice(i, 1);
            return newItems;
        });
    }

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="max-w-2xl mx-auto px-1 py-1">
                <div className="page__heading py-2 md:py-6 mt-2 md:mt-6">
                    {
                        !addMedia && !editArt &&
                        <a href={'/profile/' + params.userId}>
                            <ion-icon name="chevron-back-outline"></ion-icon> Back
                        </a>
                    }
                    {
                        addMedia &&
                        <Link onClick={() => {
                            setAddMedia(false);
                        }}>
                            <ion-icon name="chevron-back-outline"></ion-icon> Back
                        </Link>
                    }
                    {
                        editArt &&
                        <Link onClick={() => {
                            setEdit(false);
                        }}>
                            <ion-icon name="chevron-back-outline"></ion-icon> Back
                        </Link>
                    }
                    {
                        editArt &&
                        <h1> Edit Portfolio </h1>
                    }
                </div>
                {
                    ApiStatus.isLoader &&
                    <PlaceHolder />
                }
                {
                    ArtData !== null && ArtData !== "" &&
                    <>
                        {
                            params.status != null &&
                            <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">

                                <div className="md:gap-8 gap-4 items-center p-6">
                                    <div className="text-medium text-green-400">Congratulation!!</div>
                                    Your portfolio is created successfully
                                </div>
                            </div>
                        }
                        {
                            !addMedia && !editArt &&
                            <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">

                                <div className="flex md:gap-8 gap-4 items-center md:p-10 p-6">


                                    <div className="relative md:w-20 md:h-20 w-12 h-12 shrink-0">
                                        <img src={ArtData['user_pic']} alt="" className="w-full h-full absolute object-cover" />
                                    </div>

                                    <div className="flex-1">
                                        <h3 className="md:text-xl text-base font-semibold text-black dark:text-white"> {ArtData['firstName']} {ArtData['lastName']} </h3>
                                        <p className="text-sm text-blue-600 mt-1 font-normal">{ArtData['userId']}</p>
                                    </div>

                                </div>
                            </div>
                        }
                        {
                            !addMedia && !editArt &&

                            <div className="mt-6 mb-20 text-sm font-medium text-gray-600 dark:text-white/80" style={{ position: 'relative' }}>
                                {
                                    loginId === ArtData['userId'] &&
                                    <button onClick={() => {
                                        setEdit(true);
                                    }} class="button lg:px-10 bg-primary text-white max-md:flex-1" style={{ position: 'absolute', right: 15, top: 15 }}>Edit</button>

                                }

                                <div className="uk-switcher bg-white border rounded-xl shadow-sm md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">

                                    <div className="uk-active" style={{ position: 'relative' }}>

                                        <div className="space-y-4">
                                            <div className="flex items-center gap-5">
                                                <label className="w-20 md:w-32 text-right"> Artist Id </label> :
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['userId']}
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-5">
                                                <label className="w-20 md:w-32 text-right"> Gender </label> :
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['gender']}
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-5">
                                                <label className="w-20 md:w-32 text-right"> Age </label> :
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['age']}
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-5">
                                                <label className="w-20 md:w-32 text-right"> Languages known </label> :
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['lng']}
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-5">
                                                <label className="w-20 md:w-32 text-right"> Height </label> :
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['height']}
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-5">
                                                <label className="w-20 md:w-32 text-right"> Body Vitals </label> :
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['body']}
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-5">
                                                <label className="w-20 md:w-32 text-right"> City </label> :
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['city']}
                                                </div>
                                            </div>

                                            <div className="md:flex items-center gap-5" style={{ alignItems: 'baseline' }}>
                                                <label className="w-20 md:w-32 text-right font-semibold"> Work Exp. </label>
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['workExp']}
                                                </div>
                                            </div>

                                            <div className="md:flex items-center gap-5" style={{ alignItems: 'baseline' }}>
                                                <label className="w-20 md:w-32 text-right font-semibold"> Additional Info. </label>
                                                <div className="flex-1 md:mt-4">
                                                    {ArtData['info']}
                                                </div>
                                            </div>
                                            {/* {
                                                vlinks.length > 0 &&
                                                <div className="md:flex items-center gap-5" style={{ alignItems: 'baseline' }}>
                                                    <label className="w-20 md:w-32 text-right font-semibold"> Video Links </label>
                                                    <div className="flex-1 md:mt-4">
                                                        {
                                                            vlinks.map((v, k) =>
                                                                <div className="text-blue-600">
                                                                    <a key={k} target="_blank" href={v}>{v}</a>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            } */}
                                        </div>
                                        <br />
                                        <div class="flex items-center justify-between py-3">
                                            <h1 class="text-xl font-bold text-black dark:text-white">Videos</h1>
                                         
                                        </div>
                                        {
                                            vlinks.length > 0 && (
                                                <div
                                                    className="grid lg:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-3 mt-20 uk-slider-items"
                                                    uk-scrollspy="target: > div; cls: uk-animation-scale-up; delay: 100"
                                                >
                                                    {vlinks.map((url, k) => {
                                                        // Extract video ID from shorts, standard watch URLs, or share links
                                                        const videoId = url.split("/shorts/")[1] ||
                                                            url.split("v=")[1]?.split("&")[0] ||
                                                            url.split("/").pop();

                                                        const embedUrl = `https://www.youtube.com/embed/${videoId}`;

                                                        return (
                                                            <div key={k} className="relative w-full aspect-[9/16] bg-black rounded-lg overflow-hidden shadow">
                                                                <iframe
                                                                    src={embedUrl}
                                                                    title={`YouTube Video ${k + 1}`}
                                                                    className="w-full h-full border-0"
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                    allowFullScreen
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )
                                        }
                                        <br />
                                        <div class="flex items-center justify-between py-3">
                                            <h1 class="text-xl font-bold text-black dark:text-white">Photos</h1>
                                            {
                                                loginId === ArtData['userId'] &&
                                                <div class="flex items-center justify-between py-3">
                                                    <button onClick={() => {
                                                        setAddMedia(true);
                                                    }} class="button lg:px-10 bg-primary text-white max-md:flex-1">Add photos </button>
                                                </div>
                                            }

                                        </div>
                                        {
                                            photos.length > 0 &&

                                            <div className="grid lg:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-3 mt-20 uk-slider-items" uk-scrollspy="target: > div; cls: uk-animation-scale-up; delay: 100">
                                                {
                                                    photos.map((img, k) =>
                                                        <div key={k} >
                                                            <div className="-ml-2 uk-scrollspy-inview mb-6" uk-scrollspy="target: > li; cls: uk-animation-slide-right-small; delay: 50" uk-lightbox="">
                                                                <a href={img.path}>
                                                                    <div className=" lg:hover:scale-105 hover:shadow-lg hover:z-10 duration-500 delay-100">
                                                                        <div className="w-full lg:h-64 aspect-[2.5/4] realtive">
                                                                            <img src={img.path} className="rounded-lg w-full h-full object-cover inset-0" alt="" />

                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {
                                                                loginId === ArtData['userId'] &&
                                                                <Link
                                                                    onClick={() => deletePhoto(k)}
                                                                    style={{ width: 30, height: 30, alignItems: 'center', borderRadius: 15, position: 'absolute', right: 3, top: 3, backgroundColor: '#ffffffd5', color: '#000000', textAlign: 'center', alignItems: 'center', alignContent: 'center' }}>
                                                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                                </Link>
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        }
                                        <br />

                                    </div>
                                </div>
                            </div>
                        }
                        {
                            addMedia &&
                            <AddArtistPhotos subId={ArtData['subId']} setReload={setReload} setAddMedia={setAddMedia} />
                        }
                        {
                            editArt &&
                            <EditArtistProfile userData={ArtData} setReload={setReload} setEdit={setEdit} />
                        }
                    </>
                }
            </div>
        </main>
    </div>

}